module.exports = __webpack_public_path__ + "static/fonts/SourceSansPro-Light.6a9d4d2.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/scss/font/sourcesans/SourceSansPro-Light.ttf
// module id = 702
// module chunks = 3